<template>
<v-container>

    <v-card
      elevation="2"
     >
     <v-card-title>
            <h3>Configuración de Grados</h3>
          </v-card-title>
      
      <v-row >

          <v-col cols="3" sm="3">
                    <v-text-field  
                    label="Nombre"         
                    v-model="nombre"
                    v-bind:value="nombre"
                    dense
                    ></v-text-field>      
        </v-col>
        <v-col cols="3" sm="3">
                    <v-text-field  
                    label="Núm. de Orden"         
                    v-model="orden"
                    v-bind:value="orden"
                    dense
                    ></v-text-field>      
        </v-col>
        <v-col cols="3" sm="3">
            <template>
                <v-select
                label='Nivel Educativo:'
                v-model='idNivel'
                :items='niveles'
                item-value='id'
                item-text='nombre'
                dense
                @change="getIdNivel"
                >
                 <template slot='selection' slot-scope='{ item }'>
                    {{item.nombre}}
                </template>
                <template slot='item' slot-scope='{ item }'>
                    {{item.nombre}}
                </template> 

                </v-select>
            </template> 
        </v-col>
        <v-col cols="3" sm="3">
                    <v-btn
              color="primary"
              dark
              class="mb-2"
              title="Agregar Grado"
              @click="guardarGrado()"
            >Agregar</v-btn>
        </v-col>
      </v-row>


  <v-overlay :value="overlay" :absolute="absolute"><v-progress-circular indeterminate size="64"></v-progress-circular></v-overlay>

        <v-data-table
          :headers="headers"
          :items="grados"
          class="elevation-1"
        >
            <template v-slot:item.nombre="{ item }">               
                    <v-text-field                
                    v-model="item.nombre"
                    v-bind:value="item.nombre"
                    @change="actualizarNombre(item)"
                    ></v-text-field>    
            </template>
            <template v-slot:item.abreviatura="{ item }">               
                    <v-text-field                
                    v-model="item.abreviatura"
                    v-bind:value="item.abreviatura"
                    @change="actualizarAbreviatura(item)"
                    ></v-text-field>    
            </template>
            <template v-slot:item.activo="{ item }">               
                <v-switch 
                v-model="item.activo" 
                v-bind:value="item.activo"
                @change="actualizarActivo(item)"
                ></v-switch>
            </template>            
        </v-data-table>
    </v-card>
 </v-container>
</template>

<script>
   import moment from 'moment';
   moment.locale('es');
  import axios from 'axios'
  axios.defaults.withCredentials = true
  axios.defaults.baseURL = process.env.VUE_APP_API_URL
  export default {
    data:() => ({
        absolute: false,
        opacity: 0.46,
        zIndex: 5,
        nombre:'',
        orden:'',
        niveles:[],
        grados:[],
        idNivel:'',
        snack: false,
        snackColor: '',
        snackText: '',
        max25chars: v => v.length <= 25 || 'Input too long!',
        pagination: {},
        headers: [
          {text: 'Id',align: 'start',sortable: false,value: 'id'},
          {text: 'Nombre',align: 'start',sortable: false,value: 'nombre'},

          { text: 'Orden', value: 'orden'},   
          { text: 'Nivel Educativo', value: 'grado_concentrado.nombre'}, 
          { text: 'Activo', value: 'activo' },
        ],
        overlay: false,
    }),
    created () {
      this.init();
    },    
    methods: {
    init () {
      this.getNiveles()
      this.getGrados()
    }, 
    formatDate(value) {
      return moment(value,"DDMMYYYY").format('ll');
    }, 
    getIdNivel(id){
        this.idNivel = id;

    },
    guardarGrado(){
           this.$http.post('/api/grados', {
            'nombre':               this.nombre,
            'orden':                this.orden,
            'nivel':                this.idNivel
          })
          .then((response) => {
            this.getGrados()
          })
          .catch(function (error){
            console.log(error)
          }) 
    },
    actualizarActivo(item){
      if(item.alumnocontactado==null){
         item.activo = 0;
      }
      else
        item.activo = 1;
      //console.log('alumnoContactado actualizado: ' + alumnocontactado + 'id:' + id)
                this.overlay = true;
                this.$http.post('/api/niveleseducativos', {
              
                'id':               item.id,
                'atributo':         2,
                'alumnocontactado':  item.alumnocontactado,
               
                })
                 .then((response) => {
                   // console.log(response.data)
                    this.overlay = false;
                })
                .catch(function (error){
                   // console.log(error)
                    this.overlay = false;
                })
                
    },
    guardarMediodeContacto(mediodecontacto,id){
        console.log('medio contactado:' + mediodecontacto + 'del id:' + id);
                this.$http.post('/api/concentrados', {
                
                'id':               id,
                'atributo':         4,
                'mediodecontacto':  mediodecontacto,
               
                })
                 .then((response) => {
                   // console.log(response.data)
                    this.overlay = false;
                })
                .catch(function (error){
                   // console.log(error)
                    this.overlay = false;
                })
    },
    getNiveles(){
            let url = `/api/niveleseducativos?idsistema=1`
            this.$http.get(url)
            .then((response) => {
               this.niveles = response.data;
            })
            .catch(function (error){
                    console.log(error)
            }          
            )
    },
    getGrados () {
            let url = '/api/grados'
            this.$http.get(url)
            .then((response) => {
               this.grados = response.data;
               console.log(this.grados)
            })
            .catch(function (error){
                    console.log(error)
            }
          
            )
    }    
    },
    mounted(){

    } 
  }
</script>